module.exports = __webpack_public_path__ + "images/juizz0433b8ac322e7b2e23be460cc291c6a5.png";